/* ========================================
This file contains custom Javascript, to keep it separate 
from the theme Javascript found in theme.js.liquid

Because the Brooklyn theme has jQuery installed by default 
(under assets), this file also uses jQuery
======================================== */

// Causes product page to re-render when variant is selected, so that "quantity left" updates:

jQuery(function() {
    $('.single-option-selector-product-template').on('change', function(){
        setTimeout(function(){ 
          if($('[name="id"]').val() != ""){
            location.reload();
          }
        }, 1);
    });
  });


// Ensures that the Checkout button only moves forward when a delivery date is selected in the calendar
$(function() {
  $('input[name="checkout"], button[name="checkout"], input[name="goto_pp"], button[name="goto_pp"], input[name="goto_gc"]').click(function() {
    var formIsValid = true;
    var message = "Please select a delivery date and time.";

    $('[name^="attributes"]').filter('.required, [required ="required"]').each(function() {
      $(this).removeClass('error');
      if (formIsValid && ($(this).val() == "" || $(this).val() == null)) {
        formIsValid = false;
        message = $(this).attr('data-error') || message;
        $(this).addClass('error');
      }
    });
    if (formIsValid){
      $(this).submit();
    }
    else {
      alert(message);
      return false;
    }
  });
});

// Ensures that "Local Delivery" option is first in the shipping settings. We can't edit checkout directly.

